<template>
  <div id="Forget_account">
    <div class="forget_account_box">
      <Title title_name="忘記帳號"></Title>
      <div class="info">
        忘記您註冊的E-Mail(帳號)嗎？
        <br />請輸入您的手機及身分證末六碼來查詢您的帳號：
      </div>
      <div>
        <form>
          <InputBox v-for="(item, index) in input_info.slice(0, 2)" :key="item.input_id" :input_info="input_info.slice(0, 2)[index]" @input_content="input_content"></InputBox>
        </form>
      </div>
      <div class="forget_content" v-if="content">
        <p>您的帳號是: </p>
        <p>{{content}}</p>
        <!-- <p>{{sec}} 秒後回首頁</p> -->
      </div>
      <MoreButton button_text="查詢" @click.native="submit_forget_account" button_href="javascript:void(0);" :loading="loading"></MoreButton>
      <MoreButton v-if="content" button_text="回首頁" button_href="/"></MoreButton>
      <div class="notice">
        <span>請注意</span>
        <br />如您有任何問題，請撥客服電話02-2759-7167，
        <br class="br768" />我們會盡最大的努力儘快作回覆。
      </div>
    </div>
  </div>
</template>
<script>
import MoreButton from "@/components/base/MoreButton"
import Title from "@/components/base/Title"
import InputBox from "@/components/base/InputBox"
export default {
  name: "forget_account",
  components: {
    MoreButton: MoreButton,
    Title: Title,
    InputBox: InputBox
  },
  data() {
    return {
      input_info: require("@/plugins/input_info"), //input資料
      member_info: {
        phone_number: "",
        cid: ""
      },
      loading: false,
      content: "",
      sec: 6,
    };
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/";
    }
  },
  methods: {
    // 取子層的值
    input_content(v) {
      this.member_info[v[1]] = v[0];
    },
    submit_forget_account() {
      var vm = this
      var forget_account_api = vm.API + "api/member/forget/account"
      vm.loading = true
      vm.axios.post(forget_account_api, vm.member_info).then(res => {
        if (res.data.status == 200) {
          vm.content = res.data.data.account[0]
          vm.loading = false
          // 實作5秒後跳轉
          //   vm.content = res.data.data.account[0]
          //   var intervalId = setInterval(() => {
          //     if (vm.sec == 0) {
          //       clearInterval(intervalId)
          //       vm.$router.push('/')
          //     } else {
          //       vm.sec--
          //     }
          //   }, 1000)
        }
        else {
          alert("錯誤碼: " + " " + res.data.status + res.data.message)
          vm.loading = false
        }
      }).catch(function(error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
.forget_account_box {
  width: 650px;
  max-width: 100%;
  margin: auto;
  padding: 20px;
}
.forget_account_box .info {
  font-size: 18px;
  line-height: 2;
  padding: 10px 0;
}
.forget_account_box .notice {
  border-top: 1px solid black;
  padding-top: 15px;
  font-size: 18px;
  line-height: 2;
  text-align: center;
}
.forget_account_box .notice span {
  font-weight: bold;
  font-size: 22px;
}
.forget_content{
  background: antiquewhite;
  padding: 10px;
  text-align: center;
  margin-top: 15px;
}
.forget_content p{
  font-size: 20px;
  font-weight: bold;
}
@media (max-width: 768px) {
  .br768 {
    display: none;
  }
}
</style>